import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { IconName, Button } from '@optimus-web/core';
import { showAllServiceOrderNotes } from '../../../selectors';
import { toggleShowAllReservationNotes } from '../../../actions';
import { StackCleared } from './style';

const NoteListToggle = ({ handleToggle, showAllNotes }: $TSFixMe) => {
    const textKey = showAllNotes ? TextKey.CollapseNotes : TextKey.ExpandNotes;
    const iconName = showAllNotes ? IconName.ChevronUp : IconName.ChevronDown;

    return (
        <StackCleared itemAlignment="center">
            <Button variant="ghost" icon={iconName} onClick={handleToggle} type="submit">
                <LocalizedText textKey={textKey} />
            </Button>
        </StackCleared>
    );
};

export default connect(
    createStructuredSelector({
        // @ts-expect-error $TSFixMeError: No overload matches this call.
        showAllNotes: showAllServiceOrderNotes,
    }),
    // @ts-expect-error $TSFixMeError: Property 'serviceOrderId' does not exist on type '{}'.
    (dispatch, { serviceOrderId, scope }) => ({
        handleToggle: () => dispatch(toggleShowAllReservationNotes(serviceOrderId, scope)),
    })
)(NoteListToggle);
